import { articles, type Article } from "@/mocks/news";

export function getArticleById(id: string): Article | undefined {
  return articles.find((item) => item.id === id);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((item) => item.category === slug);
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  const sameCategory = articles.filter(
    (item) => item.id !== article.id && item.category === article.category,
  );
  const others = articles.filter(
    (item) => item.id !== article.id && item.category !== article.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function getLatestArticles(limit = 6): Article[] {
  return [...articles]
    .sort((a, b) => `${b.date} ${b.time}`.localeCompare(`${a.date} ${a.time}`))
    .slice(0, limit);
}

export function getFeaturedArticle(): Article {
  return articles.find((item) => item.featured) ?? articles[0];
}

export function searchArticles(keyword: string): Article[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return articles;
  return articles.filter(
    (item) =>
      item.title.toLowerCase().includes(kw) ||
      item.excerpt.toLowerCase().includes(kw) ||
      item.tags.some((tag) => tag.toLowerCase().includes(kw)) ||
      item.categoryName.toLowerCase().includes(kw),
  );
}